var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7979 6.53033C19.0908 6.23744 19.0908 5.76256 18.7979 5.46967L14.0249 0.6967C13.732 0.403807 13.2572 0.403807 12.9643 0.6967C12.6714 0.989594 12.6714 1.46447 12.9643 1.75736L17.2069 6L12.9643 10.2426C12.6714 10.5355 12.6714 11.0104 12.9643 11.3033C13.2572 11.5962 13.732 11.5962 14.0249 11.3033L18.7979 6.53033ZM0.267578 6L0.267578 6.75L18.2676 6.75L18.2676 6L18.2676 5.25L0.267578 5.25L0.267578 6Z",
    fill: "#4D5975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.4bebd956d927c890d382c231a9d62138.svg";
export { ForwardRef as ReactComponent };